import { TransporterPackage, VehicleNeeds } from '@otw/models'
import { getTruckStatus, TransportTruck } from '@otw/models/logistics'
import { DEFAULT_SAFETY_COLORS, SafetyColor, SafetyColors, TimelineInfo } from './buildInventoryV3Rows'

const colorForNeed = (
  needs: boolean,
  transporterWillInstall: boolean | undefined,
  installed: boolean | undefined,
): SafetyColor => {
  if (!needs) return 'text.secondary'
  if (installed === true) return 'success.main'
  if (transporterWillInstall === true) return 'warning.main'
  return 'error.main'
}

const colorsFromNeeds = (needs: VehicleNeeds | undefined): SafetyColors => {
  if (!needs) return DEFAULT_SAFETY_COLORS
  return {
    cameras: colorForNeed(needs.needs_cameras, needs.transporter_will_install_cameras, needs.cameras_installed),
    sensors: colorForNeed(
      needs.needs_backup_sensors,
      needs.transporter_will_install_backup_sensors,
      needs.backup_sensors_installed,
    ),
    antiTheft: colorForNeed(
      needs.needs_anti_theft,
      needs.transporter_will_install_anti_theft,
      needs.anti_theft_installed,
    ),
  }
}

export const buildSafetyAndTimelineMaps = (
  packagesByVehicleId: Map<string, TransporterPackage>,
  transportTrucks: TransportTruck[],
): {
  safetyByVehicleId: Map<string, SafetyColors>
  timelineByVehicleId: Map<string, TimelineInfo>
} => {
  const deliveredVehicleIds = new Set<string>()
  transportTrucks.forEach(truck => {
    if (!truck.vehicle_id) return
    if (getTruckStatus(truck) === 'delivered') {
      deliveredVehicleIds.add(truck.vehicle_id)
    }
  })

  const safetyByVehicleId = new Map<string, SafetyColors>()
  const timelineByVehicleId = new Map<string, TimelineInfo>()

  packagesByVehicleId.forEach((pkg, vehicleId) => {
    safetyByVehicleId.set(vehicleId, colorsFromNeeds(pkg.vehicle_needs?.[vehicleId]))
    timelineByVehicleId.set(vehicleId, {
      isInPackage: true,
      isDelivered: deliveredVehicleIds.has(vehicleId),
    })
  })

  deliveredVehicleIds.forEach(vehicleId => {
    if (timelineByVehicleId.has(vehicleId)) return
    timelineByVehicleId.set(vehicleId, { isInPackage: false, isDelivered: true })
  })

  return { safetyByVehicleId, timelineByVehicleId }
}
